import React from "react";

const Head = ({ title }) => {
  return (
    <h1
      id="header"
      className="text-xl font-semibold text-sky-600 flex-grow text-center font-['Roboto']"
    >
      {title}
    </h1>
  );
};

export default Head;
